import { PASSWORD_RULES } from '../lib/password-rules';

const STRENGTH_LABELS = ['Very weak', 'Weak', 'Fair', 'Good', 'Strong'];
const STRENGTH_COLORS = [
  'bg-ll-error',
  'bg-ll-error',
  'bg-ll-amber',
  'bg-ll-cyan',
  'bg-ll-success',
];

export function PasswordStrength({ password }: { password: string }) {
  if (!password) return null;

  const results = PASSWORD_RULES.map((rule) => ({
    label: rule.label,
    passed: rule.test(password),
  }));

  const passed = results.filter((r) => r.passed).length;
  const strengthIndex = Math.max(0, passed - 1);
  const label = STRENGTH_LABELS[strengthIndex] ?? 'Very weak';
  const color = STRENGTH_COLORS[strengthIndex] ?? 'bg-ll-error';

  return (
    <div className="-mt-2 mb-4 space-y-2">
      {/* Strength bar */}
      <div className="flex items-center gap-2">
        <div className="flex-1 flex gap-1">
          {PASSWORD_RULES.map((_, i) => (
            <div
              key={i}
              className={`h-1 flex-1 rounded-full transition-colors ${
                i < passed ? color : 'bg-ll-border'
              }`}
            />
          ))}
        </div>
        <span className="text-[10px] font-mono text-ll-muted">{label}</span>
      </div>

      {/* Rule checklist */}
      <ul className="space-y-0.5">
        {results.map((r) => (
          <li key={r.label} className="flex items-center gap-1.5 text-[11px]">
            <span className={r.passed ? 'text-ll-success' : 'text-ll-muted'}>
              {r.passed ? '\u2713' : '\u2717'}
            </span>
            <span className={r.passed ? 'text-ll-muted' : 'text-ll-muted/60'}>{r.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
